var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { InlineImage, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { arrayOf, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { isMobileResolution, shallowCompare } from '@philips-internal/oswald-ui-utils';
import LandingPageSlideAPI from './landing-page-slide-api';
import LoginLandingPageInfoCard from '../login-landing-page-info-card/login-landing-page-info-card';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './landing-page-slide.css';
let LandingPageSlide = class LandingPageSlide extends Component {
    static { this.propTypes = {
        image: string,
        infoCardsData: arrayOf(object).notEnumerable(),
        title: string
    }; }
    shouldComponentUpdate(nextProps) {
        return shallowCompare(this.props, nextProps, [
            'image',
            'infoCardsData'
        ]);
    }
    renderImage(image) {
        return (React.createElement(InlineImage, { src: image, key: generateUUID(), className: "landing-page-slide-image-container" }));
    }
    renderInfoCard(data, title) {
        const titleSize = isMobileResolution() ? TextFontSize.SMALL : TextFontSize.LARGE;
        return (React.createElement("div", { className: 'landing-page-slide-info-container', key: generateUUID() },
            title && React.createElement(Text, { value: title, className: 'landing-page-slide-title', size: titleSize }),
            React.createElement("div", { className: 'landing-page-slide-info-cards-container' }, data?.map(cardData => (React.createElement(LoginLandingPageInfoCard, { key: generateUUID(), description: cardData.description, icon: cardData.icon, title: cardData.title, onClick: cardData.onClick }))))));
    }
    render() {
        const { infoCardsData, image, title } = this.props;
        return (React.createElement("div", { className: 'landing-page-slide-container', key: generateUUID() }, image ? this.renderImage(image) : this.renderInfoCard(infoCardsData, title)));
    }
};
LandingPageSlide = __decorate([
    AwesomeComponent({ api: LandingPageSlideAPI, type: ComponentType.DATA_DISPLAY })
], LandingPageSlide);
export default LandingPageSlide;
//# sourceMappingURL=landing-page-slide.js.map